import propsToAriaRole from "./propsToAriaRole";
const roleComponents = {
  article: "article",
  banner: "header",
  blockquote: "blockquote",
  code: "code",
  complementary: "aside",
  contentinfo: "footer",
  deletion: "del",
  emphasis: "em",
  figure: "figure",
  insertion: "ins",
  form: "form",
  list: "ul",
  listitem: "li",
  main: "main",
  navigation: "nav",
  region: "section",
  strong: "strong"
};
const emptyObject = {};
const propsToAccessibilityComponent = (props = emptyObject) => {
  if (props.accessibilityRole === "label") {
    return "label";
  }
  const role = propsToAriaRole(props);
  if (role) {
    if (role === "heading") {
      const level = props.accessibilityLevel || props["aria-level"];
      if (level != null) {
        return `h${level}`;
      }
      return "h1";
    }
    return roleComponents[role];
  }
};
var propsToAccessibilityComponent_default = propsToAccessibilityComponent;
export {
  propsToAccessibilityComponent_default as default
};
//# sourceMappingURL=propsToAccessibilityComponent.js.map
